// extracted by mini-css-extract-plugin
export default {"error":"PaymentInformerStickyButton_error__ZfTot","stickyFooter":"PaymentInformerStickyButton_stickyFooter__7kdfP"};